import { Calendar } from "./calendar";

var GarageCalendar = (function(){

    let calendars = {};

    let staticOptions = {
        
        create: function(element, options){
            let $elem = document.querySelector(element);
            let calendar = new Calendar($elem, options);
            calendars[$elem] = calendar;
            return calendar;
        },

        find: function(element){
            let $elem = document.querySelector(element);
            let calendar = calendars[$elem];
            return calendar;
        }

    };

    return staticOptions;

})();

String.prototype.ucFirst = function(){
    return this.charAt(0).toUpperCase() + this.slice(1);
}

/**
 * On exporte le plugin dans l'objet window pour utilisation sur la page web.
 */
window.GarageCalendar = GarageCalendar;